import { RowSelectionData, CellParams, AccCustomAttributeObj } from './types';
import { CustomAttribute, CustomSelectAttributeValue, Rfi } from '../../../../sdk';
import { toLongDate, changeTimeZone } from '../../../../helpers';

export const createRowSelection = (ids: string[]) => {
  const mappedObj = ids.reduce((acc: RowSelectionData, id: string) => {
    acc[id] = true;
    return acc;
  }, {});
  return mappedObj;
};

export const getCellDataForCustomAttributes =
  (customAttribute: CustomAttribute, customAttributesOptionsMap: Record<string, string>) =>
  ({ row }: CellParams) => {
    const customAttributeById = (row?.original as Rfi)?.customAttributes?.reduce(
      (acc: AccCustomAttributeObj, current) => ({
        [current.id]: current,
        ...acc,
      }),
      {},
    );
    const customAttributeValue = customAttributeById?.[customAttribute.id]?.values;

    if (!customAttributeValue || !customAttributeValue.length) return '-';

    let cellData = customAttributeValue;
    if (customAttribute.dataType === 'multi_select' || customAttribute.dataType === 'select') {
      cellData = customAttributeValue.map((id) => customAttributesOptionsMap[id as string]);
    } else if (customAttribute.dataType === 'date') {
      cellData = customAttributeValue.map((val) =>
        val ? toLongDate(changeTimeZone(new Date(Number(val)), 'UTC')) : '-',
      );
    }
    return Array.isArray(cellData) ? cellData.join(', ') : cellData;
  };

export const getCustomAttributesOptionsMap = (customAttributes: CustomAttribute[]) =>
  customAttributes.reduce((acc: Record<string, string>, cur) => {
    const { dataType } = cur;
    if (dataType === 'select' || dataType === 'multi_select') {
      cur.values.forEach(({ id, name }: CustomSelectAttributeValue) => {
        acc[id] = name;
      });
    }
    return acc;
  }, {});
